import { render } from "./PaymentDatatableActions.vue?vue&type=template&id=73c18212"
import script from "./PaymentDatatableActions.vue?vue&type=script&lang=js"
export * from "./PaymentDatatableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__